interface MockRequestOptions {
  delay?: number;
  shouldFail?: boolean;
  errorMessage?: string;
}

export const mockRequest = <T>(
  payload: T,
  { delay = 300, shouldFail = false, errorMessage }: MockRequestOptions = {},
) =>
  new Promise<T>((resolve, reject) => {
    globalThis.setTimeout(() => {
      if (shouldFail) {
        reject(new Error(errorMessage || "Không thể tải dữ liệu mô phỏng."));
        return;
      }

      resolve(payload);
    }, delay);
  });
